"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  interestedParties: {
    tips: {
      AuthoritySuccess: '分配权限成功',
      bankInfoUpdateSuccess: '银行信息变更成功',
      pleaseFill: '请完善表单数据！',
      pleaseSave: '请保存数据',
      abandonSuccess: '废弃成功',
      abandonFail: '废弃失败',
      notSelf: '下级审批人不能选择自己',
      pleaseRefuseNode: '请选择驳回节点',
      notNull: '审批意见不可为空',
      selectNext: '请选择下一审批人',
      serviceCode: '服务代码已存在',
      serviceName: '服务类型中文名已存在',
      serviceNameEn: '服务类型英文名已存在',
      selectOne: '请选择一条记录',
      noAuthority: '暂无权限',
      had2black: '供应商已被加入黑名单，不能进行评估',
      hadEvaluate: '该数据已评估，请勿删除！',
      hadEvaluatIng: '该数据正在评估中，请勿删除！',
      blackTip: '确定加入黑名单吗？',
      blackSuccess: '拉黑成功',
      blackFaill: '拉黑失败，请重试！',
      updateSuccess: '更新成功',
      updateFail: '更新失败',
      notNullFillTable: '不能为空，请完善表格',
      shouldBe11: '应为11位，不满11位时提示补填XXX',
      noLowChar: '不可包含小写字母',
      containIllegalChar: '包含非法字符:',
      noNullAndNoLowChar: '不可为空且不可使用小写字母',
      messageMore: '该数据初始评估未完成、不合格或者当前部门暂无权限，不可定期评估！',
      selectNew: '请选择一条新增供应商记录',
      selectMore: '请选择至少一条记录',
      onlyDel: '只能删除追加的记录',
      sendSuccess: '发送成功',
      sendFail: '发送失败',
      conditionIsNotMet: '不满足发送条件',
      repeatEval: '当前部门已评估，请勿重复评估！',
      BankInfoUpdateSuccess: '银行信息更新成功',
      BankInfoUpdateFail: '银行信息更新失败',
      chooseRateYear: '请选择评估年度',
      disableSupplierSuccess: '禁用成功',
      disableSupplierFail: '禁用失败'
    },
    common: {
      relatedParties: '相关方管理',
      option: '操作',
      pleaseEnter: '请输入内容',
      pleaseEnterEvalBasis: '请输入开放性评估依据',
      pleaseChoose: '请选择',
      chooseDate: '选择日期',
      qualificationType: '资质类型',
      qualificationName: '资质名称',
      expireTime: '到期时间',
      startChange: '发起变更',
      saveUnimportance: '保存非重要信息',
      checkoutButton: '检查是否存在',
      tip1: '为了避免新增已经存在的供应商，请在新增之前按照以下步骤校验供应商是否已经存在：',
      tip2: '第一步：在查询区录入计划新增的供应商信息，然后点击“检查是否存在”按钮。此时系统将符合条件的供应商记录按照分类分别显示在“当前公司”、“其他公司”、“主数据”中。',
      tip3: '第⼆步：请根据系统显示数据，按照实际需要在下⾯Tab中判断是否库中已经存在',
      tip4: '1、“当前公司”：如果您要找的供应商在此Tab页中有显示，表示此供应商已经在本公司使用了，无需再新增。',
      tip5: '2、“其他公司”：“当前公司”找不到的，请到“其他公司”Tab页中查询是否存在。如果存在，表示此供应商在IMP库中存在，只是其他公司在用。请勾选此供应商，然后点击右上方的“授权”按钮，然后进行初始评估后使用。',
      tip6: '3、“主数据”：如果主数据已经存在，请勾选右上角的“新增”按钮后做初始评估使用',
      tip7: '4、如果不存在，请在主数据⻚⾯直接点击新增（不勾选）'
    },
    // 供应商管理
    supplierManage: {
      bankStatus: '银行卡状态',
      exportFile: '导出',
      supplier: '供应商管理',
      airPreparationCode: '主数据编码',
      innnerCsCust: '内部客商',
      serviceTypes: '服务类型',
      csCustCode: '客商代码',
      supplierCode: '供应商代码',
      companyName: '公司名称',
      dutyOffice: '责任部门',
      supplierName: '供应商名称',
      csCustName: '客商名称',
      ripStatus: '供应商状态',
      supplierCustomer: '供应商/客户',
      csCustStatus: '客商状态',
      applicantCompany: '申请人所属公司',
      initialAssessment: '初始评估',
      regularAssessment: '定期评估',
      supplierNameEn: '英文名称',
      abbreviation: '简称',
      countryRegion: '国家/地区',
      inOutGroup: '集团内/外',
      initialEvalDate: '初始评估日期',
      masterDataStatus: '主数据状态',
      updateStatus: '是否变更',
      yes: '是',
      no: '否',
      inGroup: '集团内',
      outGroup: '集团外',
      notApproved: '未审核',
      approved: '已审核',
      notPass: '不通过',
      serviceType: '客商类别',
      dept: '部门',
      sendPlatform: '发送主数据平台',
      authorityAssignment: '权限分配',
      handleCheckBankInfoFromMasterData: '防重复查询',
      disableBankCard: '禁用',
      startBankCard: '启用',
      blacklist: '加入黑名单',
      baseInfo: '基本信息',
      companyContactsInfo: '企业联系信息',
      csCustDealInfo: '客商交易信息',
      supplierCnName: '供应商中文名',
      csCustCnName: '客商中文名称',
      supplierEnName: '供应商英文名',
      csCustEnName: '客商英文名称',
      supplierAbbreviation: '供应商简称',
      csCustAbbreviation: '客商简称',
      supplierCode2: '供应商编码',
      csCustCode2: '客商编码',
      isFormal: '是否正式',
      newDepartments: '新增部门',
      customerGrade: '纳税信用级别',
      uniSoCreditCode: '统一社会信用代码 / 公司编码',
      tips: '境内自然人填写身份证号、境内企业填写统一社会信用代码、境外自然人填写护照号、境外企业填写邓白氏编码,香港除外、香港企业填写商业登记证',
      city: '城市',
      registeredCurrency: '注册币种',
      groupEnterpriseNature: '集团企业性质',
      beforeName: '曾用名',
      isStrategy: '是否集团战略客户',
      isListed: '是否上市公司',
      isSupplier: '是否是供应商',
      settlementcenterNm: '结算中心',
      isVip: '是否VIP客商',
      isMajorOilCompany: '是否大石油公司',
      validPeriod: '有效期限',
      settlementCurrency: '结算币种',
      earliestTradingDay: '最早交易日',
      recentTradingDay: '最近交易日',
      earliestCloseDate: '最早关闭日期',
      infoCloseDate: '信息关闭日期',
      generateLicense: '生成许可证',
      creditRateDes: '信用评级说明',
      zipCode: '邮编',
      mainMail: '主要邮箱',
      mainFax: '主要传真',
      companyWebsite: '公司网址',
      companyMailAddressCn: '通讯地址(中文)',
      companyMailAddressEn: '通讯地址(英文)',
      isCustomer: '是否是客户',
      industryClassification: '行业分类',
      partnerType: '客商类型',
      province: '省份',
      redAddress: '注册地址',
      redAddressEn: '注册地址英文',
      regDt: '注册日期',
      regPerson: '法人代表',
      regMoney: '注册资金',
      bizStatus: '企业状态',
      companyEmail: '联系邮箱',
      companyTelephone: '联系电话',
      companyOtherPhone: '其他电话',
      industry: '所属行业名称',
      corporateCode: '集团统一编码',
      parentCode: '上级客商编码',
      stockCode: '上市公司代码',
      stockName: '上市公司',
      supplierNature: '公司性质',
      providedProServices: '提供的主要产品和服务',
      contacts: '联系人',
      applicableDept: '适用部门',
      contactNum: '联系电话',
      contactDept: '联系部门',
      phone: '联系电话',
      email: '邮编',
      fax: '传真',
      emailAdrs: '邮件地址',
      contactAdrs: '联系地址',
      bankAcount: '银行账号',
      bankCheckFiles: '银⾏审核附件',
      bankCheckFilesAndBlackListCheckFile: '银⾏审核附件及列入黑名单决策文件',
      payType: '付款类型',
      auditStatus: '审核状态',
      payeeName: '收款人名称',
      payeeAddress: '收款人地址',
      payeeBank: '收款银行',
      bankNo: '收款银行行号',
      bankOther: '清算参考号',
      bankCode: '香港BANK CODE',
      currency: '币种',
      bankAdrs: '银行地址',
      payeeAcount: '收款账号',
      swiftCode: 'SWIFT CODE',
      agentBankName: '代理行名称',
      agentAddress: '代理行地址',
      agentBankAcount: '代理行账号',
      agentCountryRegion: '代理国家/地区',
      agentBankSwiftCode: '代理行SWIFT CODE',
      company: '公司',
      applicableCompany: '适用公司',
      status: '状态',
      shipName: '船名',
      businessType: '业务类型',
      financeStatus: '付款状态',
      orderNo: '订单号',
      orderDate: '订单日期',
      originalAmount: '原币金额',
      localAmount: '本位币金额',
      rate: '评分',
      ratePeople: '评分人',
      rateDate: '评分日期',
      rateYear: '评估年度',
      evaluationTimes: '业务评价次数',
      evaluationAverage: '业务评价平均分',
      evaluationGrade: '评分等级',
      moreThan: '3分以上次数',
      below: '3分以下次数',
      conclusion: '结论',
      remark: '备注',
      qualificationMaterials: '资质材料',
      notNull: '不能为空',
      lowercaseLettersCannotExist: '中文名称不能包含小写字母',
      assessed: '已评估',
      notEvaluated: '未评估',
      supplierDetails: '供应商明细',
      historyOrder: '历史订单评估',
      annualAssessment: '历史评估',
      annualAssessmentInit: '历史初始评估',
      annualAssessmentAnnual: '历史年度评估',
      historyContract: '历史合同',
      historyVoyage: '历史航次',
      csCustRate: '客商评价',
      certificates: '证书管理',
      invoicingInfo: '开票信息',
      invoiceInfo: '发票信息',
      creditManage: '授信管理',
      currentCompany: '当前公司',
      otherCompany: '其他公司',
      mainData: '主数据',
      invoiceType: '类型',
      invoiceHeader: '发票抬头',
      taxNumber: '税号',
      contactAddress: '联系地址',
      invoiceReceiver: '发票接收人',
      paymentDate: '付款日',
      currencyType: '币种',
      attachment: '附件',
      evaluationDept: '评估部门',
      evaluationDate: '评估日期',
      evaluationPeople: '填表人',
      relatedName: '相关方名称',
      relatedPeolple: '相关方联系人',
      telephone: '电话',
      officeAddress: '办公室地址',
      evaluationType: '评估类型',
      evaluationYear: '评估年份',
      evaluationMethods: '评估方法',
      evaluationBasis: '评估依据',
      relatedNature: '相关方性质',
      qualifications: '资质',
      industryReputation: '商业信誉',
      screeningResults: '筛查结果',
      relatedExpectations: '对相关方的期望和需求',
      briefIntroduction: '简介及特点',
      evaluators: '参加评估人员',
      qualification: '资质',
      creditability: '商业信誉',
      afterSalesService: '售后服务',
      serviceQuality: '服务质量',
      price: '价格合理性',
      timelinessOfQuotation: '报价及时性',
      stockingDeliveryTimeliness: '供应及时性',
      cmgBlacklistCheckResult: '招商局集团黑名单供应商筛查结果',
      domesticIntegrityAuditResult: '国内公司资信审核结果',
      foreignCompanyCreditReviewResults: '国外公司资信审核结果',
      economicSanctionsComplianceScreening: '合规审核结果',
      unqualifiedReason: '不合格原因',
      durationOfDiscontinuation: '停用期限',
      relatedPrvdProSer: '相关方提供的主要产品和服务',
      relatedTeam: '相关方管理团队',
      cooperationPerformance: '过去12个月合作表现',
      improvement: '期望改进的地方',
      evaluationconclusion: '评估结论',
      qualificationsMsg: '资质信息',
      notApplicable: '不适用',
      noNeedCheck: '未发送主数据不需要校验',
      UpperCaseLetters: '只能包含大写字母',
      changeTypeToSupplier: '变更为供应商',
      disableSupplier: '禁用供应商',
      notNumberInfo: '请输入数字,最多保留两位小数'
    },
    // 定期评估
    timeAssessment: {
      regularAssessment: '供应商定期评估',
      assessmentYear: '评估年度',
      submitter: '提交人',
      auditStatus: '状态',
      remark: '备注',
      assessmentDept: '评估部门',
      annualSummary: '年度评估汇总',
      statisticalSummary: '统计汇总',
      additionalSuppliers: '追加供应商',
      supplierMsg: '供应商信息',
      resultsEditing: '评估结果编辑',
      additional: '追 加',
      businessAssessment: '历史业务评估',
      ship: '船舶',
      businessOrderNo: '业务单号',
      afterSaleService: '售后服务',
      quotation: '报价及时性',
      priceRationality: '价格合理性',
      goodsWorkQuality: '货物/工作质量',
      goodsPreDis: '备货/配送及时性',
      totalScore: '总分',
      rater: '评分人',
      rateDate: '评分日期',
      spare: '备件'
    },
    // 其他相关方管理
    otherPartiesManage: {
      otherParties: '其他相关方管理',
      relatedCode: '相关方代码',
      relatedNameCn: '相关方中文名',
      relatedNameEn: '相关方英文名',
      relatedAbbreviation: '相关方简称',
      relatedCode2: '相关方编码',
      prvdProSer: '主要产品或服务',
      team: '管理团队',
      evaluationStatus: '评估状态',
      hasSend: '已发送未确认',
      hasConfirm: '已确认',
      noPass: '未通过',
      otherDetail: '其他相关方明细',
      evaluationHistory: '评估历史',
      changeVersion: '变更历史'
    },
    // 相关方评估监控
    evaluationMonitor: {
      Refreshmonitoringdata: '刷新监控数据',
      monitorYear: '评估年度',
      eMonitor: '相关方评估监控',
      pleaseChooseYear: '请选择年度',
      otherRealted: '其他相关方',
      allState: '全部',
      assessed: '已评估',
      underAssessed: '评估中',
      notEvaluated: '未评估',
      supplier: '供应商',
      year: '年度',
      annualSummary: '年度评估汇总',
      periodicEvaluation: '定期评估汇总',
      realtedType: '相关方类型',
      team: '管理团队',
      evaluationPeople2: '评估人'
    },
    // 评估频率配置
    frequencyConfig: {
      config: '服务类型配置',
      filterSearch: '可查询服务代码、服务类型中文名、服务类型英文名',
      evalDeptName: '监测部门',
      cooperationType: '相关方种类',
      serviceCode: '服务代码',
      serviceTypeCn: '服务类型(中文)',
      serviceType: '服务类型(英文)',
      evalFrequency: '评估频率',
      configStatus: '状态'
    },
    /* 相关方申请修改 */
    interstedModify: {
      interstedModify: '相关方修改申请',
      applyPerson: '申请人',
      applyDept: '申请部门',
      nameCn: '名称',
      nameEn: '英文姓名',
      applyStatus: '审核状态',
      applyTime: '申请时间',
      isSendMainData: '主数据审批状态',
      mainDataReason: '主数据审批理由',
      operation: '操作',
      importantMsgModify: '重要信息变更',
      modifyReason: '变更原因描述',
      historyVersion: '版本号',
      initialAssessmentStatus: '初始评估状态',
      supplierStatus: '供应商状态',
      changeData: '变更信息记录',
      nextApprover: '下级审批人'
    },
    ripType: {
      ripType: '相关方类型',
      supplier: '供应商',
      customer: '客户',
      others: '其他相关方',
      supplierCustomer: '供应商 / 客户',
      supplierOthers: '供应商 / 其他相关方',
      customerOthers: '客户 / 其他相关方',
      supplierCustomerOthers: '供应商 / 客户 / 其他相关方'
    }
  }
};